// extracted by mini-css-extract-plugin
export default {"optionPadding":"ExactnessMultiSelect_optionPadding__1WQeB"};